<template>
    <div v-if="ready && liveData.objectId" class="page">
      <!-- 头部 -->
      <header-tip
        slot="header"
        :lang-type="langType"
        :type="environment"
        path="live"
        :param="{id: objectId}"
      ></header-tip>

      <!-- <div class="box" v-if="liveData.living" > -->
      <div class="box" >
        <!-- 封面图 -->
        <tk-image class="img" :src="liveData.cover" ></tk-image>
        <!-- 头像 -->
        <div class="head" >
          <tk-image class="portrait" :src="liveData.user.avatar" width="32" height="32" ></tk-image>
          <div class="name">{{ liveData.user.nickName }}</div>
        </div>
        <!-- 按钮 -->
        <div class="button-box">
          <div class="button" @click="toNext()" >
            <div class="loadingSeven" style="display: inline-block;">
                <span></span>
                <span></span>
                <span></span>
            </div>
            <div class="m-l-4" style="display: inline-block;">{{ lang.live.enter }}</div>
          </div>
        </div>
      </div>
    </div>
    <div v-else></div>
  </template>

<script>
import headerTip from '../component/headerTip.vue'
import { liveAstrict } from '../js/callApp'
import en from './../en'
import cn from './../cn'
export default {
  components: {
    headerTip
  },
  metaInfo () {
    return {
      title: this.setting.title || ''
    }
  },
  data () {
    return {
      // metaInfo
      setting: {
        title: 'SoleStage Live'
      },
      cloudUrl: 'https://cloud.solestage.mokekeji.com',
      cloudUrlDev: 'https://cloud.solestage-dev.mokekeji.com',
      url: '',
      environment: 'dev',
      lang: {},
      langType: '',
      objectId: '',
      isInvalid: false,
      ready: false,
      liveData: {},
      isAndroid: false,
      isIos: false,
      schemeUrl: '',
      downloadUrl: ''
    }
  },
  async mounted () {
    try {
      let params = this.$route.query
      this.url = params.environment === 'dev' ? this.cloudUrlDev : this.cloudUrl
      this.environment = params.environment
      this.lang = params.lang === 'en' ? en : cn
      this.langType = params.lang
      this.objectId = params.objectId
      this.setting.title = this.langType === 'en' ? 'SoleStage Live' : 'SoleStage 直播'
      await this.init()
      setTimeout(() => {
        this.ready = true
      }, 100)
    } catch (error) {

    }
  },
  methods: {
    async init () {
      let { data: res } = await this.$tkParse.get(`${this.url}/classes/live/${this.objectId}`, {
        params: {
          include: 'user'
        }
      })
      this.liveData = res
      if (!this.liveData.living) {
        this.$router.push({
          path: './live/end',
          query: {
            environment: this.environment,
            lang: this.langType || 'cn',
            objectId: this.objectId
          }
        })
      }
    },

    async toNext () {
      if (liveAstrict()) return
      await this.init()
      if (this.liveData.living) {
        this.$router.push({
          path: './live/room',
          query: {
            environment: this.environment,
            lang: this.langType || 'cn',
            objectId: this.objectId
          }
        })
      } else {
        this.$router.push({
          path: './live/end',
          query: {
            environment: this.environment,
            lang: this.langType || 'cn',
            objectId: this.objectId
          }
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  // css 页面禁止滚动
  .page{
    background: #F5F5F5;
    width: 100%;
    height: 100vh;
    overflow: hidden;
    font-family: -apple-system, "Helvetica Neue", Helvetica, "Nimbus Sans L",
        Arial, "Liberation Sans", "PingFang SC", "Hiragino Sans GB",
        "Source Han Sans CN", "Source Han Sans SC", "Microsoft YaHei",
        "Wenquanyi Micro Hei", "WenQuanYi Zen Hei", "ST Heiti", SimHei,
        "WenQuanYi Zen Hei Sharp", sans-serif;
  }
  .box{
    position: relative;
    .img{
      width: 100%;
      height: 100vh;
    }
    .head{
      // 顶部定位，宽度根据内容自适应
      position: absolute;
      top: 15px;
      left: 15px;
      display: flex;
      align-items: center;
      padding: 3px 10px 3px 3px;
      background: rgba(0,0,0,0.5);
      border-radius: 27px;
      .portrait{
        width: 30px;
        height: 30px;
        border-radius: 50%;
        margin-right: 6px;
      }
      .name{
        color: #fff;
        font-size: 13px;
        font-weight: 700;
        font-family: BeVie-Bold;
      }
    }
    .button-box{
      position: absolute;
      top: 55%;
      left: 0;
      width: 100%;
      text-align: center;
    }
    .button{
      display: inline-block;
      cursor: pointer;
      padding: 10px 28px;
      background: rgba(0, 0, 0, 0.4);
      border: 1.5px solid rgba(255, 255, 255, 0.4);
      box-shadow: 0px 0px 4px rgba(255, 255, 255, 0.25);
      border-radius: 20px;
      color: #fff;
      font-size: 14px;
      line-height: 18px;
      font-weight: 300;
      font-family: BeVie-Light;
    }
  }

  .loadingSeven{
      height: 13px;
      margin: 0 auto;
  }
  .loadingSeven span{
      display: inline-block;
      width: 2px;
      height: 100%;
      border-radius: 4px;
      background: #fff;
      -webkit-animation: loadsaven 1.04s ease infinite;
      margin: 0 1.5px;
  }
  @-webkit-keyframes loadsaven{
      0%,100%{
          height: 5px;
          background: #fff;
      }
      50%{
          height: 13px;
          margin-top: -20px;
          background: #fff;
      }
  }
  .loadingSeven span:nth-child(2){
      -webkit-animation-delay:0.1s;
      -webkit-animation-duration:1.14s;
  }
  .loadingSeven span:nth-child(3){
      -webkit-animation-delay:0.26s;
      -webkit-animation-duration:1.24s;
  }

  </style>
